module.exports = __webpack_public_path__ + "img/home-production-02.a2aa81b9.png";